(function () {
  'use strict';

  if (window.NaturalSectionsLoaded) return;
  window.NaturalSectionsLoaded = true;

  function normalize(value) {
    return String(value || '')
      .toLocaleLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  }

  function initStoreLocator(locator, index) {
    if (locator.dataset.naturalStoreLocatorReady === 'true') return;

    var form = locator.querySelector('[data-natural-store-search]');
    var input = locator.querySelector('[data-natural-store-input]');
    var list = locator.querySelector('[data-natural-store-list]');
    var count = locator.querySelector('[data-natural-store-count]');
    var empty = locator.querySelector('[data-natural-store-empty]');
    var stores = Array.prototype.slice.call(locator.querySelectorAll('[data-natural-store]'));

    if (!form || !input || !list || !count || !empty || stores.length === 0) return;

    locator.dataset.naturalStoreLocatorReady = 'true';
    list.id = list.id || 'NaturalStoreResults-' + index;
    input.setAttribute('aria-controls', list.id);

    function updateResults() {
      var query = normalize(input.value);
      var visibleCount = 0;

      stores.forEach(function (store) {
        var isMatch = !query || normalize(store.dataset.naturalStoreSearchValue).indexOf(query) !== -1;
        store.hidden = !isMatch;
        if (isMatch) visibleCount += 1;
      });

      empty.hidden = visibleCount !== 0;
      count.textContent = query
        ? visibleCount + (visibleCount === 1 ? ' location found' : ' locations found')
        : 'Showing ' + stores.length + (stores.length === 1 ? ' location' : ' locations');
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      updateResults();
    });

    input.addEventListener('input', updateResults);
    updateResults();
  }

  function initIngredientDrawers(section) {
    if (section.dataset.naturalIngredientsReady === 'true') return;

    var content = section.querySelector('.natural-ingredients__content');
    var drawers = Array.prototype.slice.call(section.querySelectorAll('.natural-ingredients__drawer'));
    var desktopQuery = window.matchMedia('(min-width: 810px)');
    var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    var duration = 320;
    var easing = 'cubic-bezier(0.22, 1, 0.36, 1)';

    if (!content || drawers.length === 0) return;

    section.dataset.naturalIngredientsReady = 'true';
    section.dataset.naturalIngredientsMotion = 'true';

    function cancelAnimation(drawer) {
      if (!drawer._naturalIngredientsAnimation) return;
      drawer._naturalIngredientsAnimation.onfinish = null;
      drawer._naturalIngredientsAnimation.cancel();
      drawer._naturalIngredientsAnimation = null;
    }

    function lockContentHeight() {
      if (!desktopQuery.matches || content.dataset.naturalIngredientsHeightLocked === 'true') return;
      content.style.height = content.getBoundingClientRect().height + 'px';
      content.dataset.naturalIngredientsHeightLocked = 'true';
    }

    function unlockContentHeight() {
      if (drawers.some(function (drawer) { return drawer._naturalIngredientsTargetOpen; })) return;
      content.style.height = '';
      delete content.dataset.naturalIngredientsHeightLocked;
    }

    function finishImmediately(drawer, shouldOpen) {
      var panel = drawer.querySelector('.natural-ingredients__drawer-panel');
      if (!panel) return;

      cancelAnimation(drawer);
      drawer._naturalIngredientsTargetOpen = shouldOpen;
      drawer.open = shouldOpen;
      panel.style.height = shouldOpen ? 'auto' : '0px';
      panel.style.opacity = shouldOpen ? '1' : '0';
      if (!shouldOpen) unlockContentHeight();
    }

    function animateDrawer(drawer, shouldOpen) {
      var panel = drawer.querySelector('.natural-ingredients__drawer-panel');
      if (!panel) return;

      if (shouldOpen) lockContentHeight();

      var startHeight = panel.getBoundingClientRect().height;
      var startOpacity = parseFloat(window.getComputedStyle(panel).opacity) || 0;

      cancelAnimation(drawer);
      drawer._naturalIngredientsTargetOpen = shouldOpen;

      if (shouldOpen) drawer.open = true;

      panel.style.height = startHeight + 'px';
      panel.style.opacity = String(startOpacity);

      var endHeight = shouldOpen ? panel.scrollHeight : 0;
      var endOpacity = shouldOpen ? 1 : 0;

      if (reducedMotionQuery.matches || typeof panel.animate !== 'function') {
        finishImmediately(drawer, shouldOpen);
        return;
      }

      panel.style.height = endHeight + 'px';
      panel.style.opacity = String(endOpacity);

      var animation = panel.animate(
        [
          { height: startHeight + 'px', opacity: startOpacity },
          { height: endHeight + 'px', opacity: endOpacity }
        ],
        { duration: duration, easing: easing }
      );

      drawer._naturalIngredientsAnimation = animation;
      animation.onfinish = function () {
        if (drawer._naturalIngredientsAnimation !== animation) return;
        drawer._naturalIngredientsAnimation = null;

        if (shouldOpen) {
          panel.style.height = 'auto';
          panel.style.opacity = '1';
        } else {
          panel.style.height = '0px';
          panel.style.opacity = '0';
          drawer.open = false;
          unlockContentHeight();
        }
      };
    }

    function closeDrawer(drawer) {
      if (!drawer.open && !drawer._naturalIngredientsTargetOpen) return;
      animateDrawer(drawer, false);
    }

    function openDrawer(drawer) {
      drawers.forEach(function (peer) {
        if (peer !== drawer && (peer.open || peer._naturalIngredientsTargetOpen)) closeDrawer(peer);
      });
      animateDrawer(drawer, true);
    }

    function toggleDrawer(drawer) {
      if (drawer._naturalIngredientsTargetOpen) {
        closeDrawer(drawer);
      } else {
        openDrawer(drawer);
      }
    }

    drawers.forEach(function (drawer) {
      var summary = drawer.querySelector('.natural-ingredients__summary');
      var panel = drawer.querySelector('.natural-ingredients__drawer-panel');
      if (!summary || !panel) return;

      drawer.removeAttribute('name');
      drawer._naturalIngredientsTargetOpen = drawer.open;
      panel.style.height = drawer.open ? 'auto' : '0px';
      panel.style.opacity = drawer.open ? '1' : '0';

      summary.addEventListener('click', function (event) {
        event.preventDefault();
        if (event.detail === 0 && summary._naturalIngredientsKeyboardActivationAt) {
          if (Date.now() - summary._naturalIngredientsKeyboardActivationAt < 700) return;
        }
        toggleDrawer(drawer);
      });

      summary.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
        event.preventDefault();
        summary._naturalIngredientsKeyboardActivationAt = Date.now();
        toggleDrawer(drawer);
      });
    });

    desktopQuery.addEventListener('change', function () {
      if (desktopQuery.matches) {
        if (drawers.some(function (drawer) { return drawer._naturalIngredientsTargetOpen; })) {
          content.style.height = content.getBoundingClientRect().height + 'px';
          content.dataset.naturalIngredientsHeightLocked = 'true';
        }
      } else {
        content.style.height = '';
        delete content.dataset.naturalIngredientsHeightLocked;
      }
    });

    reducedMotionQuery.addEventListener('change', function () {
      drawers.forEach(function (drawer) {
        if (drawer._naturalIngredientsAnimation) {
          finishImmediately(drawer, drawer._naturalIngredientsTargetOpen);
        }
      });
    });

    if (drawers.some(function (drawer) { return drawer._naturalIngredientsTargetOpen; })) lockContentHeight();
  }

  var formsWaitlistSelector = '.natural-waitlist-app, .natural-hero__waitlist-app';

  function initFormsWaitlist(waitlist) {
    if (waitlist.dataset.naturalFormsInitialized === 'true') return;
    waitlist.dataset.naturalFormsInitialized = 'true';
    waitlist.dataset.naturalFormsReady = 'pending';

    var styleId = 'NaturalWaitlistFormsStyles';
    var pollAttempts = 0;
    var maxPollAttempts = 200;

    function getDirectFormChild(element, form) {
      var child = element;
      while (child && child.parentElement && child.parentElement !== form) {
        child = child.parentElement;
      }
      return child && child.parentElement === form ? child : null;
    }

    function markEmailField(root) {
      var email = root.querySelector('[data-testid="field-email"], input#email, input[type="email"]');
      if (!email) return false;

      var form = email.closest('form');
      if (!form) return false;

      var fieldContainer = getDirectFormChild(email, form);
      var leadCapture = form && form.querySelector('shop-lead-capture');
      var leadCaptureContainer = leadCapture && getDirectFormChild(leadCapture, form);
      var submit = form.querySelector('[data-testid="btn-form-submit"], button[type="submit"]');

      if (fieldContainer && fieldContainer.parentElement === form) {
        if (fieldContainer.getAttribute('data-natural-forms-email-field') !== 'true') {
          fieldContainer.setAttribute('data-natural-forms-email-field', 'true');
        }
      }

      if (leadCaptureContainer && leadCaptureContainer.parentElement === form) {
        if (leadCaptureContainer.getAttribute('data-natural-forms-lead-capture') !== 'true') {
          leadCaptureContainer.setAttribute('data-natural-forms-lead-capture', 'true');
        }
      }

      email.setAttribute('placeholder', 'Email address');
      email.setAttribute('type', 'email');
      email.setAttribute('autocomplete', 'email');
      email.setAttribute('inputmode', 'email');
      email.setAttribute('enterkeyhint', 'send');
      email.setAttribute('required', '');
      email.setAttribute('aria-required', 'true');

      var stretchNode = form;
      while (stretchNode && stretchNode !== root) {
        if (stretchNode.nodeType === 1) {
          stretchNode.setAttribute('data-natural-forms-stretch', 'true');
        }
        if (stretchNode.matches && stretchNode.matches('[data-testid="app-router"]')) break;
        stretchNode = stretchNode.parentElement;
      }

      if (email.id) {
        var label = root.querySelector('label[for="' + CSS.escape(email.id) + '"]');
        if (label && label.getAttribute('data-natural-forms-email-label') !== 'true') {
          label.setAttribute('data-natural-forms-email-label', 'true');
        }
      }

      return Boolean(fieldContainer && submit);
    }

    function updateFormsState(root) {
      var app = root.querySelector('#app-embed');
      if (!app) return false;

      var state = app.getAttribute('data-current-step') || 'form';
      waitlist.setAttribute('data-natural-forms-state', state);
      var formReady = markEmailField(root);

      var message = root.querySelector('[data-natural-forms-shell="true"], [role="dialog"]');
      if (message) {
        message.setAttribute('data-natural-forms-shell', 'true');
        message.removeAttribute('aria-modal');

        if (state === 'form') {
          message.setAttribute('role', 'group');
          message.setAttribute('aria-label', 'Join the Natural waitlist');
        }
      }

      if (state !== 'success') return formReady;

      if (!message) return formReady;
      message.setAttribute('role', 'region');
      message.setAttribute('aria-label', 'Waitlist confirmation');
      message.setAttribute('data-natural-forms-success', 'true');
      message.setAttribute('aria-live', 'polite');
      message.setAttribute('tabindex', '-1');

      var banner = message.querySelector('[data-testid="banner-success"]');
      var heading = message.querySelector('h1, h2, h3, [role="heading"]');
      var paragraphs = message.querySelectorAll('p');
      var body = message.querySelector('[data-testid="banner-success"] [class*="_textBody_"]');
      var paragraphIndex;

      for (paragraphIndex = 0; !body && paragraphIndex < paragraphs.length; paragraphIndex += 1) {
        if (paragraphs[paragraphIndex].textContent.trim()) {
          body = paragraphs[paragraphIndex];
          break;
        }
      }

      var contentContainer = banner && getDirectFormChild(banner, message);
      if (!contentContainer && heading) contentContainer = getDirectFormChild(heading, message);
      if (!contentContainer && body) contentContainer = getDirectFormChild(body, message);

      if (contentContainer) {
        contentContainer.setAttribute('data-natural-forms-success-content', 'true');
        Array.prototype.forEach.call(message.children, function (child) {
          if (child !== contentContainer) child.setAttribute('data-natural-forms-success-unused', 'true');
        });
      }

      if (heading) heading.setAttribute('data-natural-forms-success-heading', 'true');
      if (body) body.setAttribute('data-natural-forms-success-body', 'true');
      if (banner) banner.setAttribute('data-natural-forms-success-banner', 'true');

      if (waitlist.dataset.naturalFormsSuccessFocused === 'true') return formReady;
      waitlist.dataset.naturalFormsSuccessFocused = 'true';

      window.requestAnimationFrame(function () {
        try {
          message.focus({ preventScroll: true });
        } catch (error) {
          message.focus();
        }
      });

      return formReady;
    }

    function applyFormsStyles() {
      var embed = waitlist.querySelector('shopify-forms-embed');
      var root = embed && embed.shadowRoot;

      if (!root) return false;

      if (!root.getElementById(styleId)) {
        var style = document.createElement('style');
        style.id = styleId;
        style.textContent = [
          ':host { display: block !important; width: 100% !important; max-width: none !important; color-scheme: var(--natural-waitlist-color-scheme, light) !important; --inline-container-max-width: none !important; --inline-container-min-height: 0px !important; --forms-base-font-size: 16px !important; --forms-heading-font-size: 14px !important; --forms-accent-color: var(--natural-waitlist-accent, #eb1502) !important; }',
          '#app-embed { width: 100% !important; max-width: none !important; min-height: 0 !important; overflow: visible !important; --inline-container-min-height: 0px !important; }',
          '[data-testid="app-router"], [data-natural-forms-shell="true"], [role="dialog"], [class*="_gridItemContent_"], [class*="_formContainer_"] { width: 100% !important; max-width: none !important; min-width: 0 !important; }',
          '[data-natural-forms-shell="true"], [role="dialog"] { min-height: 0 !important; margin: 0 !important; padding: 0 !important; overflow: visible !important; border: 0 !important; background: transparent !important; box-shadow: none !important; }',
          '[class*="_gridItemContent_"] { min-height: 0 !important; padding: 0 !important; }',
          '[data-current-step="form"] [class*="_formHeader_"] { display: none !important; }',
          '[data-current-step="form"] form { position: relative !important; display: grid !important; width: 100% !important; max-width: none !important; margin: 0 !important; padding: 0 !important; grid-template-columns: minmax(0, 1fr) 10.18rem !important; align-items: start !important; gap: 0.5rem !important; }',
          '[data-current-step="form"] form > [data-natural-forms-lead-capture="true"] { position: absolute !important; width: 1px !important; height: 1px !important; overflow: hidden !important; pointer-events: none !important; }',
          '[data-current-step="form"] form > [data-natural-forms-email-field="true"] { width: 100% !important; min-width: 0 !important; grid-column: 1 !important; grid-row: 1 !important; }',
          'label[data-natural-forms-email-label="true"] { position: absolute !important; width: 1px !important; height: 1px !important; padding: 0 !important; margin: -1px !important; overflow: hidden !important; clip: rect(0 0 0 0) !important; white-space: nowrap !important; border: 0 !important; }',
          '[data-current-step="form"] form > [data-natural-forms-email-field="true"] input { box-sizing: border-box !important; width: 100% !important; height: 2.75rem !important; min-height: 2.75rem !important; min-width: 0 !important; padding: 0.52rem 1rem !important; border: 1px solid var(--natural-waitlist-field-border, #111111) !important; border-radius: 999px !important; outline: 0 !important; appearance: none !important; background: var(--natural-waitlist-field-background, #ffffff) !important; box-shadow: inset 0 0 0 0 var(--natural-waitlist-focus, #eb1502) !important; color: var(--natural-waitlist-field-text, #111111) !important; font-family: "Instrument Sans", sans-serif !important; font-size: 1rem !important; font-weight: 400 !important; line-height: 1.1 !important; transition: border-color 220ms cubic-bezier(0.22, 1, 0.36, 1), box-shadow 220ms cubic-bezier(0.22, 1, 0.36, 1) !important; }',
          '[data-current-step="form"] form > [data-natural-forms-email-field="true"] input::placeholder { color: var(--natural-waitlist-field-placeholder, rgb(17 17 17 / 56%)) !important; opacity: 1 !important; }',
          '[data-current-step="form"] form > [data-natural-forms-email-field="true"] input:focus, [data-current-step="form"] form > [data-natural-forms-email-field="true"] input:focus-visible { border-color: var(--natural-waitlist-focus, #eb1502) !important; outline: 0 !important; box-shadow: inset 0 0 0 1px var(--natural-waitlist-focus, #eb1502) !important; }',
          '[data-current-step="form"] [data-testid="btn-form-submit"], [data-current-step="form"] button[type="submit"] { box-sizing: border-box !important; display: flex !important; width: 100% !important; height: 2.75rem !important; min-height: 2.75rem !important; min-width: 10.18rem !important; padding: 0.52rem 1rem !important; border: 1px solid var(--natural-waitlist-button-border, #111111) !important; border-radius: 999px !important; outline: 0 !important; align-items: center !important; justify-content: center !important; background: var(--natural-waitlist-button-background, #ffffff) !important; box-shadow: none !important; color: var(--natural-waitlist-button-text, #111111) !important; filter: none !important; opacity: 1 !important; grid-column: 2 !important; grid-row: 1 !important; font-family: "Instrument Sans", sans-serif !important; font-size: 1rem !important; font-weight: 400 !important; letter-spacing: 0 !important; line-height: 1.1 !important; text-align: center !important; text-transform: none !important; white-space: nowrap !important; transition: background-color 220ms cubic-bezier(0.22, 1, 0.36, 1), border-color 220ms cubic-bezier(0.22, 1, 0.36, 1), color 220ms cubic-bezier(0.22, 1, 0.36, 1) !important; }',
          '[data-current-step="form"] [data-testid="btn-form-submit"]:focus-visible, [data-current-step="form"] button[type="submit"]:focus-visible { outline: 2px solid var(--natural-waitlist-focus, #eb1502) !important; outline-offset: 2px !important; }',
          '[data-current-step="form"] [data-testid="btn-form-submit"]:disabled, [data-current-step="form"] button[type="submit"]:disabled { cursor: wait !important; opacity: 0.55 !important; }',
          'div[class*="_formDisclaimer_"], [class*="_formDisclaimer_"] { grid-column: 1 / -1 !important; margin: 0 !important; margin-top: 0.5rem !important; color: var(--natural-waitlist-muted-text, rgb(17 17 17 / 56%)) !important; font-family: "Instrument Sans", sans-serif !important; font-size: 0.6875rem !important; font-weight: 400 !important; line-height: 1.35 !important; text-align: left !important; }',
          'form [class*="_error"], form > [role="alert"] { grid-column: 1 / -1 !important; color: var(--natural-waitlist-error-text, #b42318) !important; font-family: "Instrument Sans", sans-serif !important; font-size: 0.75rem !important; line-height: 1.35 !important; }',
          '[data-current-step="success"] [data-testid="app-router"], [data-current-step="success"] [class*="_formContainer_"] { width: 100% !important; align-items: stretch !important; justify-items: stretch !important; text-align: left !important; }',
          '[data-current-step="success"] [data-natural-forms-shell="true"], [data-current-step="success"] [role="dialog"] { display: grid !important; width: 100% !important; max-width: 100% !important; min-height: 4.4375rem !important; margin: 0 !important; padding: 0 !important; border: 0 !important; border-radius: 0 !important; align-items: center !important; align-self: stretch !important; justify-items: start !important; justify-self: stretch !important; grid-template-columns: 2.25rem minmax(0, 1fr) !important; gap: 0.75rem !important; background: transparent !important; box-shadow: none !important; text-align: left !important; animation: naturalFormsSuccessIn 320ms cubic-bezier(0.22, 1, 0.36, 1) both !important; }',
          '[data-current-step="success"] [data-natural-forms-shell="true"]::before, [data-current-step="success"] [role="dialog"]::before { content: "✓" !important; display: grid !important; width: 2.25rem !important; height: 2.25rem !important; border-radius: 50% !important; place-items: center !important; background: var(--natural-waitlist-success-mark-background, #eb1502) !important; color: var(--natural-waitlist-success-mark-text, #ffffff) !important; font-family: "Instrument Sans", sans-serif !important; font-size: 1rem !important; font-weight: 600 !important; line-height: 1 !important; grid-column: 1 !important; grid-row: 1 !important; animation: naturalFormsMarkIn 320ms 60ms cubic-bezier(0.22, 1, 0.36, 1) both !important; }',
          '[data-current-step="success"] [class*="_formCloseButton_"] { display: none !important; }',
          '[data-current-step="success"] [data-natural-forms-success-unused="true"] { display: none !important; }',
          '[data-current-step="success"] [data-natural-forms-success-content="true"], [data-current-step="success"] [class*="_gridItemContent_"] { display: grid !important; width: 100% !important; margin: 0 !important; padding: 0 !important; gap: 0.125rem !important; align-items: start !important; justify-items: start !important; grid-column: 2 !important; grid-row: 1 !important; text-align: left !important; }',
          '[data-current-step="success"] [data-natural-forms-success-banner="true"], [data-current-step="success"] [data-testid="banner-success"] { display: grid !important; width: 100% !important; margin: 0 !important; padding: 0 !important; gap: 0.125rem !important; align-items: start !important; justify-content: start !important; justify-items: start !important; text-align: left !important; }',
          '[data-current-step="success"] [data-natural-forms-success-heading="true"], [data-current-step="success"] h1, [data-current-step="success"] h2, [data-current-step="success"] h3, [data-current-step="success"] [role="heading"], [data-current-step="success"] [class*="_formHeader_"], [data-current-step="success"] [class*="_formBannerHeading_"] { display: grid !important; width: 100% !important; margin: 0 !important; color: var(--natural-waitlist-success-heading, #111111) !important; font-family: "Instrument Sans", sans-serif !important; font-size: 1rem !important; font-weight: 500 !important; letter-spacing: 0 !important; line-height: 1.2 !important; justify-content: start !important; justify-items: start !important; text-align: left !important; }',
          '[data-current-step="success"] [data-natural-forms-success-body="true"], [data-current-step="success"] p, [data-current-step="success"] [class*="_textBody_"] { width: 100% !important; margin: 0 !important; color: var(--natural-waitlist-success-body, rgb(17 17 17 / 62%)) !important; font-family: "Instrument Sans", sans-serif !important; font-size: 0.8125rem !important; font-weight: 400 !important; line-height: 1.35 !important; text-align: left !important; }',
          '@media (hover: hover) and (pointer: fine) { [data-current-step="form"] [data-testid="btn-form-submit"]:not(:disabled):hover, [data-current-step="form"] button[type="submit"]:not(:disabled):hover { border-color: transparent !important; background: var(--natural-waitlist-button-hover-background, #eb1502) !important; color: var(--natural-waitlist-button-hover-text, #ffffff) !important; filter: none !important; opacity: 1 !important; } }',
          '[data-current-step="form"] [data-testid="btn-form-submit"]:not(:disabled):active, [data-current-step="form"] button[type="submit"]:not(:disabled):active { border-color: transparent !important; background: var(--natural-waitlist-button-active-background, #c91e16) !important; color: var(--natural-waitlist-button-active-text, #ffffff) !important; filter: none !important; opacity: 1 !important; }',
          '@media (max-width: 1023px) { [data-current-step="form"] [data-testid="app-router"], [data-natural-forms-stretch="true"] { box-sizing: border-box !important; width: 100% !important; max-width: none !important; min-width: 0 !important; justify-self: stretch !important; align-self: stretch !important; } [data-current-step="form"] [data-testid="app-router"] { grid-template-columns: minmax(0, 1fr) !important; justify-content: stretch !important; justify-items: stretch !important; } [data-current-step="form"] [data-testid="app-router"] > *, [data-current-step="form"] [data-testid="app-router"] > * > *, [data-current-step="form"] [class*="_formContainer_"], [data-current-step="form"] [class*="_gridItemContent_"] { width: 100% !important; max-width: none !important; min-width: 0 !important; justify-self: stretch !important; } [data-current-step="form"] form { grid-template-columns: minmax(0, 1fr) !important; } [data-current-step="form"] form > [data-natural-forms-email-field="true"] { grid-column: 1 !important; grid-row: 1 !important; } [data-current-step="form"] [data-testid="btn-form-submit"], [data-current-step="form"] button[type="submit"] { min-width: 0 !important; grid-column: 1 !important; grid-row: 2 !important; } [data-current-step="success"] [data-natural-forms-shell="true"], [data-current-step="success"] [role="dialog"] { min-height: 7.68rem !important; } }',
          '@media (max-width: 480px) { [data-current-step="success"] [data-natural-forms-shell="true"], [data-current-step="success"] [role="dialog"] { width: 100% !important; } [data-current-step="success"] p, [data-current-step="success"] [class*="_textBody_"] { white-space: normal !important; } }',
          '@media (prefers-reduced-motion: reduce) { [data-current-step="form"] form > [data-natural-forms-email-field="true"] input, [data-current-step="form"] button[type="submit"], [data-current-step="success"] [data-natural-forms-shell="true"], [data-current-step="success"] [data-natural-forms-shell="true"]::before, [data-current-step="success"] [role="dialog"], [data-current-step="success"] [role="dialog"]::before { transition: none !important; animation: none !important; } }',
          '@keyframes naturalFormsSuccessIn { from { opacity: 0; transform: translateY(0.25rem); } to { opacity: 1; transform: translateY(0); } }',
          '@keyframes naturalFormsMarkIn { from { opacity: 0; transform: scale(0.9); } to { opacity: 1; transform: scale(1); } }',
        ].join('\n');
        root.appendChild(style);
      }

      if (!embed._naturalFormsRootObserver) {
        embed._naturalFormsRootObserver = new MutationObserver(function () {
          updateFormsState(root);
        });
        embed._naturalFormsRootObserver.observe(root, {
          childList: true,
          subtree: true
        });
      }

      var app = root.querySelector('#app-embed');
      var state = app && (app.getAttribute('data-current-step') || 'form');
      var formReady = updateFormsState(root);

      if (!embed._naturalFormsStateObserver) {
        if (app) {
          embed._naturalFormsStateObserver = new MutationObserver(function () {
            updateFormsState(root);
          });
          embed._naturalFormsStateObserver.observe(app, {
            attributes: true,
            attributeFilter: ['data-current-step'],
            childList: true,
            subtree: true
          });
        }
      }

      var isReady = Boolean(app && (state !== 'form' || formReady));
      if (isReady) waitlist.setAttribute('data-natural-forms-ready', 'true');
      return isReady;
    }

    function pollForEmbed() {
      if (applyFormsStyles()) {
        window.clearInterval(waitlist._naturalFormsPoll);
        waitlist._naturalFormsPoll = null;
        return;
      }

      pollAttempts += 1;
      if (pollAttempts >= maxPollAttempts) {
        window.clearInterval(waitlist._naturalFormsPoll);
        waitlist._naturalFormsPoll = null;
        waitlist.setAttribute('data-natural-forms-ready', 'failed');
      }
    }

    waitlist._naturalFormsObserver = new MutationObserver(pollForEmbed);
    waitlist._naturalFormsObserver.observe(waitlist, { childList: true, subtree: true });
    waitlist._naturalFormsPoll = window.setInterval(pollForEmbed, 100);
    pollForEmbed();
  }

  function destroyFormsWaitlist(waitlist) {
    if (waitlist._naturalFormsObserver) waitlist._naturalFormsObserver.disconnect();
    if (waitlist._naturalFormsPoll) window.clearInterval(waitlist._naturalFormsPoll);

    var embed = waitlist.querySelector('shopify-forms-embed');
    if (embed && embed._naturalFormsStateObserver) embed._naturalFormsStateObserver.disconnect();
    if (embed && embed._naturalFormsRootObserver) embed._naturalFormsRootObserver.disconnect();
  }

  var waitlistDialogSelector = '[data-natural-waitlist-dialog]';
  var waitlistDialogMotion = 220;

  function syncWaitlistDialogOpeners() {
    var openers = document.querySelectorAll('[data-natural-waitlist-open][aria-controls]');

    Array.prototype.forEach.call(openers, function (opener) {
      var targetId = opener.getAttribute('aria-controls');
      opener.hidden = !targetId || !document.getElementById(targetId);
    });
  }

  function initWaitlistDialog(dialog) {
    if (dialog.dataset.naturalWaitlistDialogReady === 'true') return;

    var closeButton = dialog.querySelector('[data-natural-waitlist-close]');
    var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    var abortController = new AbortController();
    var signal = abortController.signal;
    var opener = null;
    var closeTimer = null;
    var focusTimer = null;
    var backdropPointerDown = false;

    dialog.dataset.naturalWaitlistDialogReady = 'true';
    dialog._naturalWaitlistDialogAbortController = abortController;

    function focusDialogContent(attempt) {
      if (!dialog.open) return;

      var embed = dialog.querySelector('shopify-forms-embed');
      var root = embed && embed.shadowRoot;
      var success = dialog.querySelector('[data-natural-forms-state="success"]');
      var target = root && root.querySelector(
        success
          ? '[data-natural-forms-success="true"], [data-testid="banner-success"]'
          : '[data-natural-forms-email-field="true"] input, [data-testid="field-email"], input[type="email"]'
      );

      if (target) {
        try {
          target.focus({ preventScroll: true });
        } catch (error) {
          target.focus();
        }
        return;
      }

      if (attempt < 12) {
        focusTimer = window.setTimeout(function () {
          focusDialogContent(attempt + 1);
        }, 50);
        return;
      }

      if (closeButton) {
        try {
          closeButton.focus({ preventScroll: true });
        } catch (error) {
          closeButton.focus();
        }
      }
    }

    function finishClose() {
      if (!dialog.open) return;
      dialog.close();
    }

    function closeDialog() {
      if (!dialog.open || dialog.dataset.naturalWaitlistState === 'closing') return;

      window.clearTimeout(closeTimer);
      window.clearTimeout(focusTimer);
      dialog.dataset.naturalWaitlistState = 'closing';

      if (reducedMotionQuery.matches) {
        finishClose();
        return;
      }

      closeTimer = window.setTimeout(finishClose, waitlistDialogMotion);
    }

    function openDialog(trigger) {
      if (dialog.open) return;

      opener = trigger;
      window.clearTimeout(closeTimer);
      window.clearTimeout(focusTimer);
      dialog.dataset.naturalWaitlistState = 'opening';

      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
        dialog.setAttribute('role', 'dialog');
        dialog.setAttribute('aria-modal', 'true');
      }

      document.documentElement.classList.add('natural-waitlist-dialog-open');
      dialog.getBoundingClientRect();
      dialog.dataset.naturalWaitlistState = 'open';
      focusDialogContent(0);
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-natural-waitlist-open][aria-controls]');
      if (!trigger || trigger.getAttribute('aria-controls') !== dialog.id) return;

      event.preventDefault();
      openDialog(trigger);
    }, { signal: signal });

    if (closeButton) {
      closeButton.addEventListener('click', closeDialog, { signal: signal });
    }

    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      closeDialog();
    }, { signal: signal });

    dialog.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      event.preventDefault();
      closeDialog();
    }, { signal: signal });

    dialog.addEventListener('pointerdown', function (event) {
      backdropPointerDown = event.target === dialog;
    }, { signal: signal });

    dialog.addEventListener('click', function (event) {
      if (backdropPointerDown && event.target === dialog) closeDialog();
      backdropPointerDown = false;
    }, { signal: signal });

    dialog.addEventListener('close', function () {
      window.clearTimeout(closeTimer);
      window.clearTimeout(focusTimer);
      document.documentElement.classList.remove('natural-waitlist-dialog-open');
      dialog.removeAttribute('data-natural-waitlist-state');
      dialog.removeAttribute('aria-modal');

      if (opener && opener.isConnected) {
        try {
          opener.focus({ preventScroll: true });
        } catch (error) {
          opener.focus();
        }
      }

      opener = null;
    }, { signal: signal });

    syncWaitlistDialogOpeners();
  }

  function destroyWaitlistDialog(dialog) {
    if (dialog._naturalWaitlistDialogAbortController) {
      dialog._naturalWaitlistDialogAbortController.abort();
    }

    if (dialog.open) dialog.close();
    document.documentElement.classList.remove('natural-waitlist-dialog-open');
    delete dialog.dataset.naturalWaitlistDialogReady;
    syncWaitlistDialogOpeners();
  }

  function init(root) {
    var locators = root.matches && root.matches('[data-natural-store-locator]')
      ? [root]
      : root.querySelectorAll('[data-natural-store-locator]');
    Array.prototype.forEach.call(locators, initStoreLocator);

    var ingredientSections = root.matches && root.matches('.natural-ingredients')
      ? [root]
      : root.querySelectorAll('.natural-ingredients');
    Array.prototype.forEach.call(ingredientSections, initIngredientDrawers);

    var waitlists = root.matches && root.matches(formsWaitlistSelector)
      ? [root]
      : root.querySelectorAll(formsWaitlistSelector);
    Array.prototype.forEach.call(waitlists, initFormsWaitlist);

    var waitlistDialogs = root.matches && root.matches(waitlistDialogSelector)
      ? [root]
      : root.querySelectorAll(waitlistDialogSelector);
    Array.prototype.forEach.call(waitlistDialogs, initWaitlistDialog);
    syncWaitlistDialogOpeners();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var waitlists = event.target.matches && event.target.matches(formsWaitlistSelector)
      ? [event.target]
      : event.target.querySelectorAll(formsWaitlistSelector);
    Array.prototype.forEach.call(waitlists, destroyFormsWaitlist);

    var waitlistDialogs = event.target.matches && event.target.matches(waitlistDialogSelector)
      ? [event.target]
      : event.target.querySelectorAll(waitlistDialogSelector);
    Array.prototype.forEach.call(waitlistDialogs, destroyWaitlistDialog);
  });

})();
